// extracted by mini-css-extract-plugin
export default {"tableRow":"areaList_tableRow__WOilz","tableCell":"areaList_tableCell__vvmQQ"};